module.exports = __webpack_public_path__ + "img/1074619.jpg";